import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allFieldsAllowingFieldTemplatesSelector } from '../../../../features/apiFeatures/fieldSlice';
import { getEntityId, getRelId } from '../../../../features/helpers/apiHelpers';
import {
  setFieldTemplateModel,
  saveFieldTemplate,
  fieldTemplateBeingUpdatedSelector,
  isPanelOpenSelector,
  setIsPanelOpen,
} from '../../../../features/pageFeatures/fieldTemplateAdministrationPageSlice';
import { FieldTemplateList } from './FieldTemplateList';
import { FieldTemplatePanel } from './FieldTemplatePanel';

const FieldTemplateLists = ({
  hearingTypeId,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  selectedFieldTemplateKey,
  setSelectedFieldTemplateKey,
  onPanelOpen,
}) => {
  const dispatch = useDispatch();

  const [
    initialFieldTemplateModelText,
    setInitialFieldTemplateModelText,
  ] = useState('');

  const fields = useSelector(allFieldsAllowingFieldTemplatesSelector);
  const isPanelOpen = useSelector(isPanelOpenSelector);
  const fieldTemplateBeingUpdated = useSelector(
    fieldTemplateBeingUpdatedSelector,
  );

  const createTemplate = (fieldId) => {
    setInitialFieldTemplateModelText('');
    onPanelOpen();
    dispatch(
      setFieldTemplateModel({ fieldId: fieldId, hearingTypeId: hearingTypeId }),
    );
  };

  const onPanelClose = () => {
    dispatch(setIsPanelOpen(false));
  };

  const onSaveButton = () => dispatch(saveFieldTemplate());

  const fieldTemplateLists = fields.map((field) => (
    <FieldTemplateList
      fieldId={getEntityId(field)}
      fieldTypeId={getRelId(field, 'fieldType')}
      hearingTypeId={hearingTypeId}
      filterAndSortingSelection={filterAndSortingSelection}
      setFilterAndSortingSelection={setFilterAndSortingSelection}
      selectedFieldTemplateKey={selectedFieldTemplateKey}
      setSelectedFieldTemplateKey={setSelectedFieldTemplateKey}
      key={getEntityId(field)}
      createTemplate={createTemplate}
      setInitialFieldTemplateModelText={setInitialFieldTemplateModelText}
    />
  ));

  return (
    <div>
      {fieldTemplateLists}
      <FieldTemplatePanel
        isOpen={isPanelOpen}
        onClose={onPanelClose}
        onSaveButton={onSaveButton}
        fieldTemplateBeingUpdated={fieldTemplateBeingUpdated}
        initialFieldTemplateModelText={initialFieldTemplateModelText}
        setInitialFieldTemplateModelText={setInitialFieldTemplateModelText}
      />
    </div>
  );
};
export { FieldTemplateLists };
